// @ts-check
import { metricDisplayValues, metricNames } from '@linearb/linjs-common';

export const PREMIUM_METRICS = [
  metricNames.REVIEWS,
  metricNames.REVIEW_DEPTH,
  metricNames.NEW_WORK,
  metricNames.REFACTOR,
  metricNames.REWORK,
  metricNames.PR_MERGED_WITHOUT_REVIEW,
  metricNames.ACTIVE_DAYS,
  metricNames.BRANCH_TIME_TO_RELEASE,
  metricNames.PR_MATURITY_RATIO,
  metricNames.PR_REVIEWED
];

/**
 * Partial metric type definition
 * @typedef {object} Metric
 * @property {string} name
 */

/**
 * @typedef {object} Graph
 * @property {Metric[]} metrics
 */

/**
 * Should metric be replaced with CTA for all contributors
 * @param {boolean} isAllControbutorsTeamSelected
 * @param {Graph} graph
 * @returns {boolean}
 */
export const shouldHidePremiumMetric = (
  isAllControbutorsTeamSelected,
  graph
) => {
  if (!isAllControbutorsTeamSelected) {
    return false;
  }

  const metricName = graph.metrics?.[0]?.name;

  if (!metricName) {
    return false;
  }

  return PREMIUM_METRICS.includes(metricName);
};

/**
 * Get CTA title for a given premium metric
 * @param {Graph} graph
 * @returns {string}
 */
export const resolvePremiumMetricTitle = graph => {
  const metricName = graph.metrics?.[0]?.name;
  return metricDisplayValues[metricName]?.displayName ?? 'Premium Metric';
};

export const getCopyLink = (href, filters = {}) => {
  const url = new URL(href);
  const searchParams = new URLSearchParams(url.search);
  const selectedTimeRanges = searchParams.get('selectedTimeRanges');

  if (selectedTimeRanges) {
    return `${href}&isCopyLink=true`;
  }

  if (
    filters.selectedTimeRanges?.start_date &&
    filters.selectedTimeRanges?.end_date
  ) {
    return `${href}&selectedTimeRanges=${filters.selectedTimeRanges.start_date},${filters.selectedTimeRanges.end_date}&isCopyLink=true`;
  }

  return `${href}&isCopyLink=true`;
};
